export default "__VITE_ASSET__Bws5RmXM__"